import styled from 'styled-components'

export const Card = styled.div`
  border-radius: 10px;
`

export const ShadowCard = styled(Card)`
  background: #ffffff;
  box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.05);
  padding: 5px;
  display: inline-block;
`
